import React, { Component } from "react";
import { Card, Row, Col, Form, Button, Table, Badge, Spinner } from "react-bootstrap";
import "./_offlineExams.scss";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { withApollo } from "react-apollo";
import * as Cookies from "es-cookie";
import { components } from 'react-select';
import SelectDropDown from '../selectdropdown/SelectDropDown';
import { scopeBranches, onBranchScopeChange } from "../../../utils/branchScope";

const styles = {
  page: {
    // background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)",
    minHeight: "100vh",
    padding: "28px 24px",
  },
  statCard: {
    background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
    borderRadius: 16,
    padding: "20px 24px",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0 4px 20px rgba(99,102,241,0.3)",
    marginBottom: 24,
  },
  statLabel: { fontSize: 13, opacity: 0.85, marginBottom: 4, fontWeight: 400 },
  statValue: { fontSize: 36, fontWeight: 400, lineHeight: 1 },
  statIcon: {
    fontSize: 36,
    background: "rgba(255,255,255,0.2)",
    borderRadius: 12,
    width: 60,
    height: 60,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  card: {
    background: "#fff",
    borderRadius: 20,
    boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
    border: "none",
    marginBottom: 24,
  },
  cardHeader: {
    border: "1px solid #e5e7eb",
    background: "rgba(250, 251, 255, 1)",
    color: "#000",
    padding: "18px 24px",
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  cardHeaderTitle: {
    color: "#000",
    fontWeight: 400,
    fontSize: 17,
    margin: 0,
  },
  cardHeaderIcon: {
    width: 32,
    height: 32,
    borderRadius: 8,
    background: "rgb(224,231,255)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#6366f1",
    fontSize: 14,
  },
  cardBody: { padding: "22px 24px" },
  label: { fontSize: 12, fontWeight: 400, color: "#6b7280", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.5px" },
  input: {
    borderRadius: 10,
    border: "1.5px solid #e5e7eb",
    padding: "9px 14px",
    fontSize: 14,
    color: "#1f2937",
    background: "#f9fafb",
    transition: "border-color 0.2s",
    width: "100%",
  },
  addBtn: {
    background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    border: "none",
    borderRadius: 10,
    padding: "9px 20px",
    fontWeight: 400,
    fontSize: 14,
    color: "#fff",
    width: "100%",
    boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
    cursor: "pointer",
  },
  tableWrapper: {
    overflowX: "auto",
  },
  thead: {},
  th: {
    color: "#000",
    padding: "16px",
    fontSize: "14px",
    fontWeight: "600",
    whiteSpace: "nowrap",
    border: "1px solid #e5e7eb",
    background: "rgba(250, 251, 255, 1)",
  },
  td: {
    padding: "13px 16px",
    verticalAlign: "middle",
    fontSize: 14,
    color: "#374151",
    borderBottom: "1px solid #f3f4f6",
    border: "none",
  },
  idBadge: {
    background: "linear-gradient(135deg, #dbeafe, #ede9fe)",
    color: "#4f46e5",
    borderRadius: 20,
    padding: "3px 12px",
    fontWeight: 400,
    fontSize: 12,
    display: "inline-block",
    border: "1px solid #c7d2fe",
  },
  phaseName: { fontWeight: 400, color: "#1f2937" },
  standardPill: {
    background: "#f0fdf4",
    color: "#15803d",
    borderRadius: 20,
    padding: "3px 12px",
    fontWeight: 400,
    fontSize: 12,
    display: "inline-block",
    border: "1px solid #bbf7d0",
  },
  yearPill: {
    background: "#fff7ed",
    color: "#c2410c",
    borderRadius: 20,
    padding: "3px 12px",
    fontWeight: 400,
    fontSize: 12,
    display: "inline-block",
    border: "1px solid #fed7aa",
  },
  editBtn: {
    background: "linear-gradient(135deg, #f59e0b, #d97706)",
    border: "none",
    borderRadius: 8,
    padding: "5px 14px",
    fontWeight: 400,
    fontSize: 12,
    color: "#fff",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(245,158,11,0.3)",
  },
  saveBtn: {
    background: "linear-gradient(135deg, #10b981, #059669)",
    border: "none",
    borderRadius: 8,
    padding: "5px 14px",
    fontWeight: 400,
    fontSize: 12,
    color: "#fff",
    cursor: "pointer",
    marginRight: 6,
    boxShadow: "0 2px 8px rgba(16,185,129,0.3)",
  },
  cancelBtn: {
    background: "#f3f4f6",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    padding: "5px 14px",
    fontWeight: 400,
    fontSize: 12,
    color: "#6b7280",
    cursor: "pointer",
  },
  emptyState: {
    textAlign: "center",
    padding: "48px 20px",
    color: "#9ca3af",
  },
  emptyIcon: { fontSize: 48, marginBottom: 12, display: "block" },
  emptyText: { fontWeight: 400, fontSize: 15, color: "#6b7280", margin: 0 },
  emptySubText: { fontSize: 13, color: "#9ca3af", marginTop: 4 },
  filterRow: {
    display: "flex",
    gap: 12,
    alignItems: "flex-end",
    flexWrap: "wrap",
  },
  filterItem: { flex: "1 1 180px", minWidth: 160 },
  sectionDivider: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
    flexWrap: "wrap",
    gap: 12,
  },
  countChip: {
    background: "linear-gradient(135deg, #ede9fe, #dbeafe)",
    color: "#4f46e5",
    borderRadius: 20,
    padding: "4px 14px",
    fontWeight: 400,
    fontSize: 13,
    border: "1px solid #c7d2fe",
  },
  deleteBtn: {
    background: "linear-gradient(135deg, #ef4444, #dc2626)",
    border: "none",
    borderRadius: 8,
    padding: "5px 14px",
    fontWeight: 600,
    fontSize: 12,
    color: "#fff",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(239,68,68,0.3)",
  },
  pageSizeSelect: {
    padding: "6px 12px",
    borderRadius: 8,
    border: "1.5px solid #c084fc",
    background: "#f3e8ff",
    color: "#6b21a8",
    outline: "none",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 13,
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 16,
    padding: "16px 20px",
    borderTop: "1px solid #e5e7eb",
    background: "#fff",
  },
  paginationInfo: {
    fontSize: 14,
    color: "#4b5563",
  },
  paginationButtons: {
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  pageBtn: {
    padding: "6px 12px",
    fontSize: 13,
    fontWeight: 600,
    borderRadius: 8,
    border: "1.5px solid #e5e7eb",
    background: "#fff",
    color: "#4b5563",
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 36,
    height: 36,
  },
  pageBtnActive: {
    background: "#dee2e6",
    color: "#1f2937",
    borderColor: "#dee2e6",
  },
  pageBtnDisabled: {
    background: "#f3f4f6",
    color: "#d1d5db",
    borderColor: "#e5e7eb",
    cursor: "not-allowed",
  },
};


const GET_BRANCHES = gql`
  query getBranches($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
      sections {
        id
        class_id
        section_name
      }
    }
  }
`;

const GET_EXAM_SESSIONS = gql`
  query getExamSessions($class_id:Int!,$exam_phase_id:Int!){
    getExamSessions(
      exam_phase_id: $exam_phase_id
      class_id: $class_id
    ){
      exam_session_id
      subject_id
      subject_name
    }
  }
`;

const GET_EXAM_GRADING_SCALE = gql`
  query getExamGradingScale(
    $exam_session_id: Int!
  ) {
    getExamGradingScale( 
      exam_session_id: $exam_session_id
    ) {
       id
    min_marks
    max_marks
    grade
    }
  }
`;


const CREATE_EXAM_GRADING_SCALE = gql`
  mutation createExamGradingScale($grading: [SessionGradingInput!]!) {
    createExamGradingScale(grading: $grading)
  }
`;

const GET_EXAM_PHASE_GRADING_SCALE = gql`
  query getExamPhaseGradingScale($academic_year_id:Int!,$exam_phase_id:Int!,$class_id:Int!){
    getExamPhaseGradingScale(
      exam_phase_id: $exam_phase_id
      academic_year_id: $academic_year_id
      class_id:$class_id
    ){
      id
    exam_phase
    min_marks
    max_marks
    grade
    academic_year
    class
    academic_year_id
    class_id
      exam_phase_id
    }
  }
`;


const CREATE_EXAM_PHASE_GRADING_SCALE = gql`
    mutation createExamPhaseGradingScale(
        $data: [ExamPhaseGradingScaleInput!]
    ) {
        createExamPhaseGradingScale(
            data: $data
        )
    }
`;


class ExamInternals extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeEntryType: "overall",
      selectedClass: "",
      selectedExam: "",
      selectedAcademicYear: "",
      selectedSubject: "",
      loader: 0,
      loaderSubjects: 0,
      mainSubjects: [],
      subjects: [],
      errors: {},
      isSubmit: false,
      showConfig: false,
      selectedClassValue: "",
      selectedAcademicYearValue: "",
      selectedExamValue: "",
      fetchIntenalLoader: 0,
      getExamPhaseGradingScaleData: [],
      currentPage: 1,
      pageSize: 10,
    };
  };

  componentDidMount() {
    const firstYear = this.props.getYears?.[0];
    if (firstYear) {
      this.setState({
        selectedAcademicYear: String(firstYear.id),
        selectedAcademicYearValue: String(firstYear.id),
      });
    }
    // Branch comes from the header (NavbarOne). Both tabs derive their Class list
    // from it, so a change can invalidate the current Class on either tab.
    this.offBranchScope = onBranchScopeChange(() => {
      const okSubject = this.getFilteredClasses().some((c) => String(c.id) === String(this.state.selectedClass));
      const okOverall = this.getFilteredClassesOverAll().some((c) => String(c.id) === String(this.state.selectedClassValue));
      const patch = { showConfig: false, mainSubjects: [], getExamPhaseGradingScaleData: [] };
      if (!okSubject) { patch.selectedClass = ""; patch.selectedSubject = ""; patch.subjects = []; }
      if (!okOverall) { patch.selectedClassValue = ""; }
      this.setState(patch);
    });
  }

  componentWillUnmount() {
    if (this.offBranchScope) this.offBranchScope();
  }


  mapApiToState = (data = []) => {
    return data.map((item) => ({
      id: item.id,
      min_marks: item.min_marks ?? "",
      max_marks: item.max_marks ?? "",
      grade: item.grade || "",
      estatus: item.estatus ?? 1,
    }));
  };

  // Classes offered by any branch the header currently has in scope. Both tabs
  // share it now that neither owns a Branch dropdown.
  getScopedClasses = () => {
    const { getBranchesQuery, getClasses } = this.props;
    const branches = scopeBranches(getBranchesQuery?.getBranches || []);
    const classIds = [...new Set(branches.flatMap((b) => (b.sections || []).map((s) => s.class_id)))];
    return (getClasses || []).filter((c) => classIds.includes(c.id));
  };

  getFilteredClasses = () => this.getScopedClasses();

  getFilteredClassesOverAll = () => this.getScopedClasses();

  handleFetchData = async () => {
    const { selectedClass, selectedExam, selectedAcademicYear, selectedSubject } = this.state;

    if (!selectedClass || !selectedExam || !selectedAcademicYear || !selectedSubject) {
      toast.error("Please select all filters");
      return;
    }

    this.setState(prev => ({
      ...prev,
      loader: 1,
    }));

    try {
      const res = await this.props.client.query({
        query: GET_EXAM_GRADING_SCALE,
        variables: {
          exam_session_id: +this.state.selectedSubject
        },
        fetchPolicy: "no-cache",
      });

      const apiData = res?.data?.getExamGradingScale || [];

      this.setState({
        mainSubjects: this.mapApiToState(apiData),
        showConfig: true,
        currentPage: 1,
      });

      if (apiData.length === 0) {
        this.handleAddRow();
      }

    } catch (err) {
      console.error(err);
    } finally {
      this.setState(prev => ({
        ...prev,
        loader: 0,
      }))
    }
  };


  handleDropdown = (field, e) => {
    const value = e.target.value;
    const extraReset = {};

    this.setState(
      {
        [field]: value,
        showConfig: false,
        mainSubjects: [],
        currentPage: 1,
        ...extraReset,
      },
      () => {
        const { selectedClass, selectedExam, selectedAcademicYear, selectedSubject } = this.state;
        if (field === "selectedSubject") {
          if (selectedClass && selectedExam && selectedAcademicYear && selectedSubject) {
            this.handleFetchData();
          }
        } else {
          if (selectedClass && selectedExam && selectedAcademicYear) {
            this.handleFetchSubject();
          }
        }
      }
    );
  };

  handleDropdownOverAll = (field, e) => {
    const value = e.target.value;
    const extraReset = {};

    this.setState(
      {
        [field]: value,
        showConfig: false,
        getExamPhaseGradingScaleData: [],
        currentPage: 1,
        ...extraReset,
      },
      () => {
        const { selectedClassValue, selectedExamValue, selectedAcademicYearValue } = this.state;
        if (selectedClassValue && selectedExamValue && selectedAcademicYearValue) {
          this.handleFetchExamPhaseGradingScale();
        }
      }
    );
  };

  handleSelectChange = (name, value) => {
    const extraReset = {};
    this.setState(
      { [name]: String(value), showConfig: false, mainSubjects: [], currentPage: 1, ...extraReset },
      () => {
        const { selectedClass, selectedExam, selectedAcademicYear, selectedSubject } = this.state;
        if (name === "selectedSubject") {
          if (selectedClass && selectedExam && selectedAcademicYear && selectedSubject) {
            this.handleFetchData();
          }
        } else {
          if (selectedClass && selectedExam && selectedAcademicYear) {
            this.handleFetchSubject();
          }
        }
      }
    );
  };

  handleSelectChangeOverAll = (name, value) => {
    const extraReset = {};
    this.setState(
      { [name]: String(value), showConfig: false, getExamPhaseGradingScaleData: [], currentPage: 1, ...extraReset },
      () => {
        const { selectedClassValue, selectedExamValue, selectedAcademicYearValue } = this.state;
        if (selectedClassValue && selectedExamValue && selectedAcademicYearValue) {
          this.handleFetchExamPhaseGradingScale();
        }
      }
    );
  };

  // Add new row
  handleAddRow = () => {
    const { selectedClass, selectedAcademicYear, selectedExam } = this.state;

    this.setState((prev) => ({
      mainSubjects: [
        ...prev.mainSubjects,
        {
          id: 0,
          min_marks: "",
          max_marks: "",
          grade: "",
          estatus: 1,
        },
      ],
    }));
  };

  // Handle input change
  handleInputChange = (index, field, value) => {
    this.setState((prev) => {
      const updated = [...prev.mainSubjects];
      updated[index][field] = value;
      return { mainSubjects: updated };
    });
  };

  // Remove row
  handleRemoveRow = (index) => {
    this.setState((prev) => {
      const updated = [...prev.mainSubjects];
      const row = updated[index];

      if (row.id && row.id > 0) {
        // ✅ Existing record → mark as inactive
        updated[index] = {
          ...row,
          estatus: 0,
        };
      } else {
        // ✅ New row → remove completely
        updated.splice(index, 1);
      }

      return { mainSubjects: updated };
    }, () => {
      toast.info("Row removed. Click Save Configuration to apply changes.");
    });
  };

  validateRows = () => {
    const errors = {};
    let errorMessages = [];

    this.state.mainSubjects.forEach((item, index) => {
      if (item.estatus === 0) return;

      const rowError = {};

      // ✅ Min Marks
      if (item.min_marks === "" || item.min_marks === null) {
        rowError.min_marks = "Min marks required";
        errorMessages.push(`Row ${index + 1}: Min marks required`);
      } else if (isNaN(item.min_marks)) {
        rowError.min_marks = "Must be a number";
        errorMessages.push(`Row ${index + 1}: Min marks must be a number`);
      }

      // ✅ Max Marks
      if (item.max_marks === "" || item.max_marks === null) {
        rowError.max_marks = "Max marks required";
        errorMessages.push(`Row ${index + 1}: Max marks required`);
      } else if (isNaN(item.max_marks)) {
        rowError.max_marks = "Must be a number";
        errorMessages.push(`Row ${index + 1}: Max marks must be a number`);
      }

      // ✅ Logical validation
      if (
        item.min_marks !== "" &&
        item.max_marks !== "" &&
        +item.min_marks > +item.max_marks
      ) {
        rowError.min_marks = "Min should be ≤ Max";
        rowError.max_marks = "Max should be ≥ Min";
        errorMessages.push(
          `Row ${index + 1}: Min marks should be less than or equal to Max marks`
        );
      }

      // ✅ Grade
      // if (!item.grade || !item.grade.trim()) {
      //   rowError.grade = "Grade is required";
      //   errorMessages.push(`Row ${index + 1}: Grade is required`);
      // }

      if (Object.keys(rowError).length > 0) {
        errors[index] = rowError;
      }
    });

    this.setState({ errors });

    // 🔥 Toast (show first error only)
    if (errorMessages.length > 0) {
      toast.error(errorMessages[0]);
    }

    return Object.keys(errors).length === 0;
  };

  handleSave = async () => {
    const isValid = this.validateRows();
    if (!isValid) return;

    const { selectedClass, selectedExam, selectedAcademicYear, selectedSubject } = this.state;

    this.setState(prev => ({
      ...prev,
      isSubmit: true,
    }));

    try {
      const gradingData = {
        exam_session_id: parseInt(selectedSubject),
        inserted_by: parseInt(Cookies.get("id")),
        grades: this.state.mainSubjects.map((subject) => ({
          id: subject.id || undefined,
          min_marks: parseInt(subject.min_marks) || 0,
          max_marks: parseInt(subject.max_marks) || 0,
          // grade: subject.grade || "",
          grade:"",
          estatus: subject.estatus ?? 1,
        })),
      };

      const response = await this.props.createExamGradingScale({
        variables: {
          grading: [gradingData],
        },
      });

      if (response.data.createExamGradingScale) {
        toast.success("Configuration saved successfully!");
        this.setState(
          {
            isSubmit: false,
            loader: 0,
            loaderSubjects: 0,
            errors: {},
            showConfig: false,
            fetchIntenalLoader: 0,
          },
          async () => {
            await this.handleFetchSubject();
            if (this.state.selectedSubject) {
              await this.handleFetchData();
            }
          }
        );
      } else {
        toast.error("Could not save configuration");
        this.setState({ isSubmit: false });
      }
    } catch (error) {
      console.error("Error saving configuration:", error);
      toast.error("Error saving configuration");
      this.setState({ isSubmit: false });
    }
  };


  handleFetchSubject = async () => {
    const { selectedClass, selectedExam, selectedAcademicYear } = this.state;

    if (!selectedClass || !selectedExam || !selectedAcademicYear) {
      return; // ❌ no toast here (avoid spam)
    }

    this.setState({ loaderSubjects: 1 });

    try {
      const res = await this.props.client.query({
        query: GET_EXAM_SESSIONS,
        variables: {
          exam_phase_id: +selectedExam,
          class_id: +selectedClass,
        },
        fetchPolicy: "no-cache",
      });

      const apiData = res?.data?.getExamSessions || [];

      this.setState({
        subjects: apiData, // ✅ IMPORTANT
        showConfig: false,
      });

    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch subjects");
    } finally {
      this.setState({ loaderSubjects: 0 });
    }
  };


  handleEntryTypeChange = (type) => {
    this.setState(
      (prev) => {
        const next = {
          activeEntryType: type,
          loader: 0,
          loaderSubjects: 0,
          mainSubjects: [],
          subjects: [],
          errors: {},
          isSubmit: false,
          showConfig: false,
          getExamPhaseGradingScaleData: [],
          currentPage: 1,
          pageSize: 10,
        };

        // Branch no longer takes part in the Subject-wise ↔ Overall sync: both tabs
        // read the same header scope, so there is nothing per-tab left to carry over.
        if (type === "overall") {
          next.selectedAcademicYearValue = prev.selectedAcademicYearValue || prev.selectedAcademicYear || "";
          next.selectedClassValue = prev.selectedClassValue || prev.selectedClass || "";
          next.selectedExamValue = prev.selectedExamValue || prev.selectedExam || "";
        } else {
          next.selectedAcademicYear = prev.selectedAcademicYear || prev.selectedAcademicYearValue || "";
          next.selectedClass = prev.selectedClass || prev.selectedClassValue || "";
          next.selectedExam = prev.selectedExam || prev.selectedExamValue || "";
          next.selectedSubject = "";
        }

        return next;
      },
      () => {
        if (type === "overall") {
          const { selectedClassValue, selectedExamValue, selectedAcademicYearValue } = this.state;
          if (selectedClassValue && selectedExamValue && selectedAcademicYearValue) {
            this.handleFetchExamPhaseGradingScale();
          }
        } else {
          const { selectedClass, selectedExam, selectedAcademicYear } = this.state;
          if (selectedClass && selectedExam && selectedAcademicYear) {
            this.handleFetchSubject();
          }
        }
      }
    );
  };

  handleOverallInputChange = (index, field, value) => {
    this.setState((prev) => {
      const updated = [...prev.getExamPhaseGradingScaleData];
      updated[index][field] = value;
      return { getExamPhaseGradingScaleData: updated };
    });
  };

  handleAddOverallRow = () => {
    const { selectedExamValue, selectedClassValue, selectedAcademicYearValue } = this.state;
    const examPhaseObj = this.props.getExamPhase?.find((p) => +p.id === +selectedExamValue);
    const classObj = this.props.getClasses?.find((c) => +c.id === +selectedClassValue);
    const yearObj = this.props.getYears?.find((y) => +y.id === +selectedAcademicYearValue);

    this.setState((prev) => ({
      getExamPhaseGradingScaleData: [
        ...prev.getExamPhaseGradingScaleData,
        {
          id: 0,
          exam_phase_id: +selectedExamValue,
          class_id: +selectedClassValue,
          exam_phase: examPhaseObj ? `${examPhaseObj.exam_phase}` : "",
          academic_year: yearObj?.academic_year || "",
          class: classObj?.class || "",
          min_marks: "",
          max_marks: "",
          grade: "",
          estatus: 1,
        },
      ],
    }));
  };

  handleRemoveOverallRow = (index) => {
    this.setState((prev) => {
      const updated = [...prev.getExamPhaseGradingScaleData];
      const row = updated[index];

      if (row.id && row.id > 0) {
        updated[index] = {
          ...row,
          estatus: 0,
        };
      } else {
        updated.splice(index, 1);
      }

      return { getExamPhaseGradingScaleData: updated };
    }, () => {
      toast.info("Row removed. Click Save Configuration to apply changes.");
    });
  };

  handleFetchExamPhaseGradingScale = async () => {
    const { selectedClassValue, selectedExamValue, selectedAcademicYearValue } = this.state;

    if (!selectedClassValue || !selectedExamValue || !selectedAcademicYearValue) {
      toast.error("Please select all filters");
      return;
    }

    this.setState({ fetchIntenalLoader: 1, showConfig: false, getExamPhaseGradingScaleData: [] });

    try {
      const res = await this.props.client.query({
        query: GET_EXAM_PHASE_GRADING_SCALE,
        variables: {
          exam_phase_id: +selectedExamValue,
          class_id: +selectedClassValue,
          academic_year_id: +selectedAcademicYearValue,
        },
        fetchPolicy: "no-cache",
      });

      const apiData = (res?.data?.getExamPhaseGradingScale || []).map((item) => ({
        ...item,
        estatus: item.estatus ?? 1,
      }));
      this.setState({ getExamPhaseGradingScaleData: apiData, showConfig: true, currentPage: 1 });
      if (apiData.length === 0) {
        this.handleAddOverallRow();
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch data");
    } finally {
      this.setState({ fetchIntenalLoader: 0 });
    }
  };

  handleUpdateOverAllMarks = async () => {
    const { getExamPhaseGradingScaleData } = this.state;
    const errors = {};
    const errorMessages = [];

    getExamPhaseGradingScaleData.forEach((item, index) => {
      if (item.estatus === 0) return;

      const rowError = {};
      if (item.min_marks === "" || item.min_marks === null) {
        rowError.min_marks = "Min marks required";
        errorMessages.push(`Row ${index + 1}: Min marks required`);
      }
      if (item.max_marks === "" || item.max_marks === null) {
        rowError.max_marks = "Max marks required";
        errorMessages.push(`Row ${index + 1}: Max marks required`);
      }
      // if (!item.grade || !String(item.grade).trim()) {
      //   rowError.grade = "Grade is required";
      //   errorMessages.push(`Row ${index + 1}: Grade is required`);
      // }
      if (Object.keys(rowError).length > 0) errors[index] = rowError;
    });

    this.setState({ errors });
    if (errorMessages.length > 0) {
      toast.error(errorMessages[0]);
      return;
    }

    this.setState({
      isSubmitting: true
    });

    try {
      // CREATE PAYLOAD FROM TABLE DATA
      const payload =
        this.state.getExamPhaseGradingScaleData.map(
          (item) => ({
            id: Number(item.id),
            exam_phase_id: Number(item.exam_phase_id),
            min_marks: Number(item.min_marks),
            max_marks: Number(item.max_marks),
            // grade: String(item.grade || "").trim(),
            grade:"",
            class_id: Number(item.class_id),
            updated_by: parseInt(Cookies.get("id")),
            estatus: item.estatus ?? 1,
          })
        );

      const response = await this.props.createExamPhaseGradingScale({
        variables: {
          data: payload,
        },
      });

      if (
        response?.data?.createExamPhaseGradingScale
      ) {
        toast.success(
          "Marks Config Updated Successfully"
        );

        this.setState(
          {
            errors: {},
            isSubmit: false,
            showConfig: false,
            fetchIntenalLoader: 0,
            getExamPhaseGradingScaleData: [],
          },
          () => {
            this.handleFetchExamPhaseGradingScale();
          }
        );
      } else {
        toast.error(
          "Failed to Update Marks Config"
        );
      }
    } catch (error) {
      console.error(error);

      toast.error(
        error.message ||
        "Something went wrong"
      );
    } finally {
      this.setState({
        isSubmitting: false
      });
    }
  };

  render() {
    const { selectedAcademicYear, currentPage, pageSize } = this.state;

    return (
      <div style={styles.page}>
        {/* Top Section */}

        <Row className="justify-content-center mb-2">
          <Col lg={5} md={7} sm={12}>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "14px",
                flexWrap: "wrap"
              }}
            >

              {/* Overall Marks */}
              <button
                onClick={() =>
                  this.handleEntryTypeChange("overall")
                }
                style={{
                  border: "none",
                  outline: "none",
                  padding: "11px 20px",
                  borderRadius: "12px",
                  fontSize: "14px",
                  fontWeight: "700",
                  cursor: "pointer",
                  transition: "0.3s ease-in-out",
                  display: "flex",
                  alignItems: "center",
                  gap: "9px",
                  minWidth: "190px",
                  justifyContent: "center",

                  background:
                    this.state.activeEntryType === "overall"
                      ? "linear-gradient(135deg, #2563eb, #3b82f6)"
                      : "#eff6ff",

                  color:
                    this.state.activeEntryType === "overall"
                      ? "#ffffff"
                      : "#2563eb",

                  border:
                    this.state.activeEntryType === "overall"
                      ? "1px solid #2563eb"
                      : "1px solid #bfdbfe",

                  boxShadow:
                    this.state.activeEntryType === "overall"
                      ? "0 5px 14px rgba(37,99,235,0.28)"
                      : "none"
                }}
              >
                📊  Overall Marks
              </button>

              {/* Subject Wise */}
              <button
                onClick={() =>
                  this.handleEntryTypeChange("subjectwise")
                }
                style={{
                  border: "none",
                  outline: "none",
                  padding: "11px 20px",
                  borderRadius: "12px",
                  fontSize: "14px",
                  fontWeight: "700",
                  cursor: "pointer",
                  transition: "0.3s ease-in-out",
                  display: "flex",
                  alignItems: "center",
                  gap: "9px",
                  minWidth: "190px",
                  justifyContent: "center",

                  background:
                    this.state.activeEntryType === "subjectwise"
                      ? "linear-gradient(135deg, #059669, #10b981)"
                      : "#ecfdf5",

                  color:
                    this.state.activeEntryType === "subjectwise"
                      ? "#ffffff"
                      : "#059669",

                  border:
                    this.state.activeEntryType === "subjectwise"
                      ? "1px solid #059669"
                      : "1px solid #a7f3d0",

                  boxShadow:
                    this.state.activeEntryType === "subjectwise"
                      ? "0 5px 14px rgba(5,150,105,0.28)"
                      : "none"
                }}
              >
                📚  Subject Wise Marks
              </button>
            </div>
          </Col>
        </Row>

        {
          this.state.activeEntryType === "subjectwise" ? (
            <div style={styles.card}>
              <div style={styles.cardHeader}>
                <div style={styles.cardHeaderIcon}>
                  <i className="fas fa-book-open" />
                </div>
                <h5 style={styles.cardHeaderTitle}>Subject Wise Grading</h5>
              </div>

              <div style={styles.cardBody}>
                <Row className="g-3">
                  {/* Academic Year */}
                  <Col xs={12} sm={6} md={3}>
                    <div style={styles.label}>Academic Year</div>
                    <SelectDropDown
                      name="selectedAcademicYear"
                      placeholderName="Select Academic Year"
                      options={(this.props.getYears || []).map((year) => ({ value: year.id, label: year.academic_year, id: year.id }))}
                      stateData={(this.props.getYears || []).map((year) => ({ value: year.id, label: year.academic_year, id: year.id })).find((opt) => String(opt.value) === String(this.state.selectedAcademicYear)) || null}
                      handleChange={this.handleSelectChange}
                      isClearable={false}
                    />
                  </Col>

                  {/* No Branch filter — the header's branch selection scopes this page. */}

                  {/* Class */}
                  <Col xs={12} sm={6} md={2}>
                    <div style={styles.label}>Select Class</div>
                    <SelectDropDown
                      name="selectedClass"
                      placeholderName="Select Class"
                      options={this.getFilteredClasses().map((cls) => ({ value: cls.id, label: cls.class, id: cls.id }))}
                      stateData={this.getFilteredClasses().map((cls) => ({ value: cls.id, label: cls.class, id: cls.id })).find((opt) => String(opt.value) === String(this.state.selectedClass)) || null}
                      handleChange={this.handleSelectChange}
                      isClearable={false}
                    />
                  </Col>

                  {/* Exam Phase */}
                  <Col xs={12} sm={6} md={3}>
                    <div style={styles.label}>Exam Phase</div>
                    <SelectDropDown
                      name="selectedExam"
                      placeholderName="Select Exam Phase"
                      options={(this.props.getExamPhase || []).filter((item) => +item.academic_year_id === +this.state.selectedAcademicYear).map((item) => ({ value: item.id, label: `${item.exam_phase} - ${item.exam_standard_name}`, id: item.id }))}
                      stateData={(this.props.getExamPhase || []).filter((item) => +item.academic_year_id === +this.state.selectedAcademicYear).map((item) => ({ value: item.id, label: `${item.exam_phase} - ${item.exam_standard_name}`, id: item.id })).find((opt) => String(opt.value) === String(this.state.selectedExam)) || null}
                      handleChange={this.handleSelectChange}
                      isClearable={false}
                    />
                  </Col>

                  {this.state.loaderSubjects === 1 ? (
                    <Col xs={12} sm={6} md={2}>
                      <Spinner animation="border" />
                    </Col>
                  ) : (
                    <Col xs={12} sm={6} md={2}>
                      <div style={styles.label}>Select Subject</div>
                      <SelectDropDown
                        name="selectedSubject"
                        placeholderName="Select Subject"
                        options={(this.state.subjects || []).map((s) => ({ value: s.exam_session_id, label: s.subject_name, id: s.exam_session_id }))}
                        stateData={(this.state.subjects || []).map((s) => ({ value: s.exam_session_id, label: s.subject_name, id: s.exam_session_id })).find((opt) => String(opt.value) === String(this.state.selectedSubject)) || null}
                        handleChange={this.handleSelectChange}
                        isClearable={false}
                      />
                    </Col>
                  )}

                </Row>
              </div>


              {/* Loader */}
              {this.state.loader === 1 && (
                <div style={styles.emptyState}>
                  <Spinner animation="border" />
                </div>
              )}

              {/* Empty State - Subject Wise */}
              {/* {!this.state.loader && !this.state.showConfig && (
                <div style={styles.card} className="mt-4">
                  <div style={styles.cardHeader}>
                    <div style={styles.cardHeaderIcon}>
                      <i className="fas fa-chart-bar" />
                    </div>
                    <h5 style={styles.cardHeaderTitle}>Marks Range Configuration</h5>
                  </div>
                  <div style={styles.emptyState}>
                    <span style={styles.emptyIcon}>👆</span>
                    <p style={styles.emptyText}>Select one or more classes to view subjects Wise Marks</p>
                  </div>
                </div>
              )} */}

              {/* Table Section */}
              {!this.state.loader && this.state.showConfig && (
                <div style={styles.card}>
                  <div style={styles.cardHeader}>
                    <div style={styles.cardHeaderDot}></div>
                    <h5 style={styles.cardHeaderTitle}>
                      Marks Range Configuration
                    </h5>

                    <div style={{ marginLeft: "auto" }}>
                      <button style={styles.editBtn} onClick={this.handleAddRow}>
                        + Add Row
                      </button>
                    </div>
                  </div>

                  <div style={styles.cardBody}>
                    {(() => {
                      const activeMappedSubjects = this.state.mainSubjects
                        .map((item, i) => ({ item, i }))
                        .filter(({ item }) => item.estatus !== 0);

                      const pageSizeNum = this.state.pageSize === "All" ? activeMappedSubjects.length : parseInt(this.state.pageSize, 10);
                      const totalPages = this.state.pageSize === "All" ? 1 : Math.ceil(activeMappedSubjects.length / pageSizeNum) || 1;

                      let activePage = this.state.currentPage;
                      if (activePage > totalPages) {
                        activePage = totalPages;
                      }
                      if (activePage < 1) {
                        activePage = 1;
                      }

                      const startIndex = this.state.pageSize === "All" ? 0 : (activePage - 1) * pageSizeNum;
                      const paginatedMappedSubjects = activeMappedSubjects.slice(startIndex, startIndex + pageSizeNum);

                      const showingStart = activeMappedSubjects.length === 0 ? 0 : startIndex + 1;
                      const showingEnd = Math.min(startIndex + pageSizeNum, activeMappedSubjects.length);
                      const showingText = `Showing ${showingStart} to ${showingEnd} of ${activeMappedSubjects.length} Results`;

                      const pageNumbers = [];
                      const maxVisibleButtons = 5;
                      let startPage = Math.max(1, activePage - Math.floor(maxVisibleButtons / 2));
                      let endPage = Math.min(totalPages, startPage + maxVisibleButtons - 1);
                      if (endPage - startPage + 1 < maxVisibleButtons) {
                        startPage = Math.max(1, endPage - maxVisibleButtons + 1);
                      }
                      for (let pNum = startPage; pNum <= endPage; pNum++) {
                        if (pNum >= 1 && pNum <= totalPages) {
                          pageNumbers.push(pNum);
                        }
                      }

                      const paginationFooter = (
                        <div style={styles.paginationContainer}>
                          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <select
                              style={styles.pageSizeSelect}
                              value={this.state.pageSize}
                              onChange={(e) => {
                                const val = e.target.value;
                                this.setState({
                                  pageSize: val === "All" ? "All" : parseInt(val, 10),
                                  currentPage: 1,
                                });
                              }}
                            >
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                              <option value="All">All</option>
                            </select>
                            <div style={styles.paginationInfo}>{showingText}</div>
                          </div>
                          <div style={styles.paginationButtons}>
                            <button
                              type="button"
                              style={{
                                ...styles.pageBtn,
                                ...(activePage === 1 ? styles.pageBtnDisabled : {}),
                              }}
                              disabled={activePage === 1}
                              onClick={() => this.setState({ currentPage: activePage - 1 })}
                            >
                              <i className="fa fa-chevron-left" style={{ fontSize: 11 }} />
                            </button>

                            {startPage > 1 && (
                              <>
                                <button
                                  type="button"
                                  style={{
                                    ...styles.pageBtn,
                                    ...(activePage === 1 ? styles.pageBtnActive : {}),
                                  }}
                                  onClick={() => this.setState({ currentPage: 1 })}
                                >
                                  1
                                </button>
                                {startPage > 2 && <span style={{ color: "#9ca3af", padding: "0 4px" }}>...</span>}
                              </>
                            )}

                            {pageNumbers.map((page) => (
                              <button
                                key={page}
                                type="button"
                                style={{
                                  ...styles.pageBtn,
                                  ...(activePage === page ? styles.pageBtnActive : {}),
                                }}
                                onClick={() => this.setState({ currentPage: page })}
                              >
                                {page}
                              </button>
                            ))}

                            {endPage < totalPages && (
                              <>
                                {endPage < totalPages - 1 && <span style={{ color: "#9ca3af", padding: "0 4px" }}>...</span>}
                                <button
                                  type="button"
                                  style={{
                                    ...styles.pageBtn,
                                    ...(activePage === totalPages ? styles.pageBtnActive : {}),
                                  }}
                                  onClick={() => this.setState({ currentPage: totalPages })}
                                >
                                  {totalPages}
                                </button>
                              </>
                            )}

                            <button
                              type="button"
                              style={{
                                ...styles.pageBtn,
                                ...(activePage === totalPages ? styles.pageBtnDisabled : {}),
                              }}
                              disabled={activePage === totalPages}
                              onClick={() => this.setState({ currentPage: activePage + 1 })}
                            >
                              <i className="fa fa-chevron-right" style={{ fontSize: 11 }} />
                            </button>
                          </div>
                        </div>
                      );

                      return (
                        <div style={{ border: "1px solid #e5e7eb", borderRadius: 12, overflow: "hidden", marginBottom: 20 }}>
                          <div style={styles.tableWrapper}>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                              <thead style={styles.thead}>
                                <tr>
                                  {["Sno", "Min Marks", "Max Marks", "Action"].map(
                                    (h) => (
                                      <th key={h} style={styles.th}>{h}</th>
                                    )
                                  )}
                                </tr>
                              </thead>

                              <tbody>
                                {activeMappedSubjects.length === 0 ? (
                                  <tr>
                                    <td colSpan="5" style={styles.td}>
                                      <div style={styles.emptyState}>
                                        <span style={styles.emptyIcon}>📭</span>
                                        <p style={styles.emptyText}>No data found</p>
                                      </div>
                                    </td>
                                  </tr>
                                ) : (
                                  paginatedMappedSubjects.map(({ item, i }, index) => {
                                    const displayIndex = startIndex + index;
                                    const error = this.state.errors[i] || {};

                                    return (
                                      <tr key={item.id ? `row-${item.id}` : `new-${i}`}>
                                        <td style={styles.td}>{displayIndex + 1}</td>

                                        <td style={styles.td}>
                                          <Form.Control
                                            type="number"
                                            size="sm"
                                            placeholder="Enter Min Marks"
                                            value={item.min_marks || ""}
                                            onChange={(e) =>
                                              this.handleInputChange(i, "min_marks", e.target.value)
                                            }
                                          />
                                        </td>

                                        <td style={styles.td}>
                                          <Form.Control
                                            type="number"
                                            size="sm"
                                            placeholder="Enter Max Marks"
                                            value={item.max_marks || ""}
                                            onChange={(e) =>
                                              this.handleInputChange(i, "max_marks", e.target.value)
                                            }
                                          />
                                        </td>

                                        <td style={styles.td}>
                                          {activeMappedSubjects.length > 1 && (
                                            <button
                                              type="button"
                                              style={styles.deleteBtn}
                                              onClick={() => this.handleRemoveRow(i)}
                                              title="Remove this Marks Config row"
                                            >
                                              Delete
                                            </button>
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })
                                )}
                              </tbody>
                            </table>
                          </div>
                          {paginationFooter}
                        </div>
                      );
                    })()}

                    {/* Save */}
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
                      <button
                        style={styles.saveBtn}
                        onClick={this.handleSave}
                        disabled={this.state.isSubmit}
                      >
                        {this.state.isSubmit ? "Saving..." : "Save Configuration"}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <>
              <div style={styles.card}>
                <div style={styles.cardHeader}>
                  <div style={styles.cardHeaderIcon}>
                    <i className="fas fa-chart-line" />
                  </div>
                  <h5 style={styles.cardHeaderTitle}>Total Marks Config</h5>
                </div>

                <div style={styles.cardBody}>
                  <Row className="g-3">
                    {/* Academic Year */}
                    <Col xs={12} sm={6} md={3}>
                      <div style={styles.label}>Academic Year</div>
                      <SelectDropDown
                        name="selectedAcademicYearValue"
                        placeholderName="Select Academic Year"
                        options={(this.props.getYears || []).map((year) => ({ value: year.id, label: year.academic_year, id: year.id }))}
                        stateData={(this.props.getYears || []).map((year) => ({ value: year.id, label: year.academic_year, id: year.id })).find((opt) => String(opt.value) === String(this.state.selectedAcademicYearValue)) || null}
                        handleChange={this.handleSelectChangeOverAll}
                        isClearable={false}
                      />
                    </Col>

                    {/* No Branch filter — the header's branch selection scopes this page. */}

                    {/* Class */}
                    <Col xs={12} sm={6} md={3}>
                      <div style={styles.label}>Select Class</div>
                      <SelectDropDown
                        name="selectedClassValue"
                        placeholderName="Select Class"
                        options={this.getFilteredClassesOverAll().map((cls) => ({ value: cls.id, label: cls.class, id: cls.id }))}
                        stateData={this.getFilteredClassesOverAll().map((cls) => ({ value: cls.id, label: cls.class, id: cls.id })).find((opt) => String(opt.value) === String(this.state.selectedClassValue)) || null}
                        handleChange={this.handleSelectChangeOverAll}
                        isClearable={false}
                      />
                    </Col>

                    {/* Exam Phase */}
                    <Col xs={12} sm={6} md={3}>
                      <div style={styles.label}>Exam Phase</div>
                      <SelectDropDown
                        name="selectedExamValue"
                        placeholderName="Select Exam Phase"
                        options={(this.props.getExamPhase || []).filter((item) => +item.academic_year_id === +this.state.selectedAcademicYearValue).map((item) => ({ value: item.id, label: `${item.exam_phase} - ${item.exam_standard_name}`, id: item.id }))}
                        stateData={(this.props.getExamPhase || []).filter((item) => +item.academic_year_id === +this.state.selectedAcademicYearValue).map((item) => ({ value: item.id, label: `${item.exam_phase} - ${item.exam_standard_name}`, id: item.id })).find((opt) => String(opt.value) === String(this.state.selectedExamValue)) || null}
                        handleChange={this.handleSelectChangeOverAll}
                        isClearable={false}
                      />
                    </Col>

                  </Row>

                  {this.state.fetchIntenalLoader === 1 && (
                    <div style={styles.emptyState}>
                      <Spinner animation="border" />
                    </div>
                  )}

                  {!this.state.fetchIntenalLoader && this.state.showConfig && (
                    <>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: 20,
                          marginBottom: 10,
                        }}
                      >
                        <span style={{ fontWeight: 700, fontSize: 14, color: "#374151" }}>
                           Marks Config ({this.state.getExamPhaseGradingScaleData.filter((s) => s.estatus !== 0).length} record{this.state.getExamPhaseGradingScaleData.filter((s) => s.estatus !== 0).length !== 1 ? "s" : ""})
                        </span>
                        <button style={styles.editBtn} onClick={this.handleAddOverallRow}>
                          + Add Row
                        </button>
                      </div>

                      {(() => {
                        const activeMappedOverall = this.state.getExamPhaseGradingScaleData
                          .map((item, index) => ({ item, index }))
                          .filter(({ item }) => item.estatus !== 0);

                        const pageSizeNumOverall = pageSize === "All" ? activeMappedOverall.length : parseInt(pageSize, 10);
                        const totalPagesOverall = pageSize === "All" ? 1 : Math.ceil(activeMappedOverall.length / pageSizeNumOverall) || 1;

                        let activePageOverall = currentPage;
                        if (activePageOverall > totalPagesOverall) {
                          activePageOverall = totalPagesOverall;
                        }
                        if (activePageOverall < 1) {
                          activePageOverall = 1;
                        }

                        const startIndexOverall = pageSize === "All" ? 0 : (activePageOverall - 1) * pageSizeNumOverall;
                        const paginatedMappedOverall = activeMappedOverall.slice(startIndexOverall, startIndexOverall + pageSizeNumOverall);

                        const showingStartOverall = activeMappedOverall.length === 0 ? 0 : startIndexOverall + 1;
                        const showingEndOverall = Math.min(startIndexOverall + pageSizeNumOverall, activeMappedOverall.length);
                        const showingTextOverall = `Showing ${showingStartOverall} to ${showingEndOverall} of ${activeMappedOverall.length} Results`;

                        const pageNumbersOverall = [];
                        const maxVisibleButtonsOverall = 5;
                        let startPageOverall = Math.max(1, activePageOverall - Math.floor(maxVisibleButtonsOverall / 2));
                        let endPageOverall = Math.min(totalPagesOverall, startPageOverall + maxVisibleButtonsOverall - 1);
                        if (endPageOverall - startPageOverall + 1 < maxVisibleButtonsOverall) {
                          startPageOverall = Math.max(1, endPageOverall - maxVisibleButtonsOverall + 1);
                        }
                        for (let pNum = startPageOverall; pNum <= endPageOverall; pNum++) {
                          if (pNum >= 1 && pNum <= totalPagesOverall) {
                            pageNumbersOverall.push(pNum);
                          }
                        }

                        const paginationFooterOverall = (
                          <div style={styles.paginationContainer}>
                            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                              <select
                                style={styles.pageSizeSelect}
                                value={pageSize}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  this.setState({
                                    pageSize: val === "All" ? "All" : parseInt(val, 10),
                                    currentPage: 1,
                                  });
                                }}
                              >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value="All">All</option>
                              </select>
                              <div style={styles.paginationInfo}>{showingTextOverall}</div>
                            </div>
                            <div style={styles.paginationButtons}>
                              <button
                                type="button"
                                style={{
                                  ...styles.pageBtn,
                                  ...(activePageOverall === 1 ? styles.pageBtnDisabled : {}),
                                }}
                                disabled={activePageOverall === 1}
                                onClick={() => this.setState({ currentPage: activePageOverall - 1 })}
                              >
                                <i className="fa fa-chevron-left" style={{ fontSize: 11 }} />
                              </button>

                              {startPageOverall > 1 && (
                                <>
                                  <button
                                    type="button"
                                    style={{
                                      ...styles.pageBtn,
                                      ...(activePageOverall === 1 ? styles.pageBtnActive : {}),
                                    }}
                                    onClick={() => this.setState({ currentPage: 1 })}
                                  >
                                    1
                                  </button>
                                  {startPageOverall > 2 && <span style={{ color: "#9ca3af", padding: "0 4px" }}>...</span>}
                                </>
                              )}

                              {pageNumbersOverall.map((page) => (
                                <button
                                  key={page}
                                  type="button"
                                  style={{
                                    ...styles.pageBtn,
                                    ...(activePageOverall === page ? styles.pageBtnActive : {}),
                                  }}
                                  onClick={() => this.setState({ currentPage: page })}
                                >
                                  {page}
                                </button>
                              ))}

                              {endPageOverall < totalPagesOverall && (
                                <>
                                  {endPageOverall < totalPagesOverall - 1 && <span style={{ color: "#9ca3af", padding: "0 4px" }}>...</span>}
                                  <button
                                    type="button"
                                    style={{
                                      ...styles.pageBtn,
                                      ...(activePageOverall === totalPagesOverall ? styles.pageBtnActive : {}),
                                    }}
                                    onClick={() => this.setState({ currentPage: totalPagesOverall })}
                                  >
                                    {totalPagesOverall}
                                  </button>
                                </>
                              )}

                              <button
                                type="button"
                                style={{
                                  ...styles.pageBtn,
                                  ...(activePageOverall === totalPagesOverall ? styles.pageBtnDisabled : {}),
                                }}
                                disabled={activePageOverall === totalPagesOverall}
                                onClick={() => this.setState({ currentPage: activePageOverall + 1 })}
                              >
                                <i className="fa fa-chevron-right" style={{ fontSize: 11 }} />
                              </button>
                            </div>
                          </div>
                        );

                        return (
                          <div style={{ border: "1px solid #e5e7eb", borderRadius: 12, overflow: "hidden", marginBottom: 20 }}>
                            <div style={styles.tableWrapper}>
                              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead style={styles.thead}>
                                  <tr>
                                    {["Exam Phase", "Year", "Class", "Min Marks", "Max Marks", "Action"].map(
                                      (h) => (
                                        <th key={h} style={styles.th}>{h}</th>
                                      )
                                    )}
                                  </tr>
                                </thead>

                                <tbody>
                                  {activeMappedOverall.length === 0 ? (
                                    <tr>
                                      <td colSpan="7" style={styles.td}>
                                        <div style={styles.emptyState}>
                                          <span style={styles.emptyIcon}>📭</span>
                                          <p style={styles.emptyText}>No data found</p>
                                          <p style={styles.emptySubText}>Use the &quot;+ Add Row&quot; button above to add grading entries.</p>
                                        </div>
                                      </td>
                                    </tr>
                                  ) : (
                                    paginatedMappedOverall.map(({ item, index }) => {
                                      const error = this.state.errors[index] || {};

                                      return (
                                        <tr key={item.id ? `row-${item.id}` : `new-${index}`}>
                                          <td style={styles.td}>
                                            {item.exam_phase}
                                          </td>

                                          <td style={styles.td}>
                                            {item.academic_year}
                                          </td>

                                          <td style={styles.td}>
                                            {item.class}
                                          </td>

                                          <td style={{ textAlign: "center" }}>
                                            <Form.Control
                                              type="number"
                                              value={item.min_marks}
                                              placeholder="Enter Min Marks"
                                              isInvalid={!!error.min_marks}
                                              onChange={(e) =>
                                                this.handleOverallInputChange(index, "min_marks", e.target.value)
                                              }
                                              style={{
                                                borderRadius: "10px",
                                                height: "42px",
                                                textAlign: "center",
                                                border: error.min_marks ? "1px solid #ef4444" : "1px solid #d1d5db",
                                                boxShadow: "none",
                                              }}
                                            />
                                          </td>

                                          <td style={{ textAlign: "center" }}>
                                            <Form.Control
                                              type="number"
                                              value={item.max_marks}
                                              placeholder="Enter Max Marks"
                                              isInvalid={!!error.max_marks}
                                              onChange={(e) =>
                                                this.handleOverallInputChange(index, "max_marks", e.target.value)
                                              }
                                              style={{
                                                borderRadius: "10px",
                                                height: "42px",
                                                textAlign: "center",
                                                border: error.max_marks ? "1px solid #ef4444" : "1px solid #d1d5db",
                                                boxShadow: "none",
                                              }}
                                            />
                                          </td>

                                          <td style={styles.td}>
                                            {activeMappedOverall.length > 1 && (
                                              <button
                                                type="button"
                                                style={styles.deleteBtn}
                                                onClick={() => this.handleRemoveOverallRow(index)}
                                                title="Remove this Marks Config row"
                                              >
                                                Delete
                                              </button>
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    })
                                  )}
                                </tbody>
                              </table>
                            </div>
                            {paginationFooterOverall}
                          </div>
                        );
                      })()}

                      {this.state.getExamPhaseGradingScaleData.length > 0 && (
                        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
                          <button
                            style={styles.saveBtn}
                            onClick={this.handleUpdateOverAllMarks}
                            disabled={this.state.isSubmitting}
                          >
                            {this.state.isSubmitting ? "Saving..." : "Save Configuration"}
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </>
          )
        }
      </div>
    );
  }
}

export default withRouter(withApollo(compose(
  graphql(GET_BRANCHES, {
    options: () => ({
      variables: {
        institution_id: parseInt(Cookies.get("institutionid")),
      },
    }),
    name: "getBranchesQuery",
  }),
  graphql(CREATE_EXAM_GRADING_SCALE, {
    name: "createExamGradingScale",
  }),
  graphql(CREATE_EXAM_PHASE_GRADING_SCALE, {
    name: "createExamPhaseGradingScale",
  }),
)(ExamInternals),
));